console.log('common.ts');

// =====================
// jQuery
// =====================
import jQuery from "jquery";
(window as any).$ = (window as any).jQuery = jQuery;
export default jQuery;

// =====================
// Moment.js
// =====================
import moment from "moment";
import "moment/dist/locale/hu";
(window as any).moment = moment;

// =====================
// Constants
// =====================
export const readytrigger = "ready";

// =====================
// Utility functions
// =====================
export function getUrlParameter(sParam: string): string | boolean | undefined {
  const sPageURL = decodeURIComponent(window.location.search.substring(1));
  const sURLVariables = sPageURL.split("&");

  for (const sVariable of sURLVariables) {
    const [key, value] = sVariable.split("=");
    if (key === sParam) {
      return value === undefined ? true : value;
    }
  }
}

export function getObjects(obj: any, key: string, val: any): any[] {
  let objects: any[] = [];
  for (const i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] === "object") {
      objects = objects.concat(getObjects(obj[i], key, val));
    } else if (i === key && obj[key] === val) {
      objects.push(obj);
    }
  }
  return objects;
}

export function selectObjects<T extends Record<string, any>, K extends keyof T>(
  arr: T[],
  key: K,
  val: T[K]
): T[] {
  if (!Array.isArray(arr)) return [];
  return arr.filter((v) => v[key] === val);
}

export function loader(show: boolean) {
  if (show) {
    $("#loaderoverlay").show();
    $(".loader").addClass("active");
  } else {
    $(".loader").removeClass("active");
    $("#loaderoverlay").hide();
  }
}

(window as any).loader = loader;

export function showOverlayAndSubmit() {
  $("#loaderoverlay").show();
  $(".loader").addClass("active");
  $(".cont_form").submit();
}

export function myGetNumValue(str: any): number | null {
  return $.isNumeric(str) ? parseFloat(str) : null;
}

export function roundTo(number: number | null, precision: number): number | null {
  return number != null
    ? Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision)
    : null;
}

export function p(object: any) {
  console.log(object);
  //if (window.Android) {
  //  Android.log(object);
  //}
}

export function hasMouse(): boolean {
  return window.matchMedia('(pointer: fine)').matches;
}

// =====================
// jQuery extensions
// =====================
declare global {
  interface JQuery {
    myHighliht(): JQuery;
    myScrollTo(offset?: number): JQuery;
    myScrollToFormGroup(offset?: number): JQuery;
    myGetNumValue(): number | null;
    myKeydown(key: string, callback?: (e: JQuery.KeyDownEvent) => void): void;
  }
}

$.fn.extend({
  myHighliht() {
    const old = $(this).css("backgroundColor");
    $(this).finish().css({ backgroundColor: "green" }).animate(
      { backgroundColor: old },
      3000
    );
    return $(this);
  },

  myScrollTo(offset?: number) {
    $("html,body").animate(
      { scrollTop: $(this).offset()!.top - (offset || 0) },
      "fast"
    );
    return $(this);
  },

  myScrollToFormGroup(offset?: number) {
    $("html,body").animate(
      { scrollTop: $(this).closest(".form-group").offset()!.top - (offset || 0) },
      "fast"
    );
    return $(this);
  },

  myGetNumValue() {
    return $.isNumeric($(this).val()) ? parseFloat($(this).val() as string) : null;
  },

  myKeydown(key: string, callback?: (e: JQuery.KeyDownEvent) => void) {
    $(this).on("keydown", (e) => {
      const active = document.activeElement;
      const isTyping =
        active &&
        (active.tagName === "INPUT" ||
          active.tagName === "TEXTAREA" ||
          active.tagName === "SELECT"); //||active.isContentEditable
      if (!isTyping && e.key === key && callback) {
        callback(e);
        e.preventDefault();
      }
    });
  },
});
